import React from 'react'
import { List, ListItemButton, ListItemIcon, ListItemText, Popover } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Delete } from '@mui/icons-material'

type CustomersActionsMenuProps = {
    anchorEl?: null | HTMLElement
    id?: string
    onClose: () => void
    onDeleteCustomer: (id: string) => void
}

export const CustomersActionsMenu: React.FC<CustomersActionsMenuProps> = ({
    anchorEl,
    onClose,
    onDeleteCustomer,
    id,
}) => {
    const { t } = useTranslation()

    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            onClose={onClose}
            PaperProps={{ sx: { minWidth: 200 } }}
        >
            <List sx={{ width: '100%' }}>
                <ListItemButton onClick={() => onDeleteCustomer(id!)}>
                    <ListItemIcon>
                        <Delete color="error" />
                    </ListItemIcon>
                    <ListItemText primary={t('common.delete')} />
                </ListItemButton>
            </List>
        </Popover>
    )
}
